import { FC } from 'react'
import { Typography, Grid } from '@mui/material'
// import SortByComponent from './SortBy'

interface RecentBillsLedgerHeaderProps {
  sortType: string
  onSortChange: (sortType: string) => void
}

const RecentBillsLedgerHeader: FC<RecentBillsLedgerHeaderProps> = ({
  sortType: _sortType,
  onSortChange: _onSortChange,
}) => {
  return (
    <Grid container alignItems="center">
      <Grid item md={3}>
        <Typography variant="h3" component="h3" gutterBottom pl={2.5}>
          Create Bulk Invoices
        </Typography>
      </Grid>
      <Grid item md={2.5} />
      {/* Sort hidden for bulk invoice stepper flow — restore when needed
      <Grid
        md={6.5}
        item
        sx={{
          width: 250,
          textAlign: 'right',
          display: 'flex',
          justifyContent: 'right',
          alignItems: 'center',
          minHeight: 58,
        }}
      >
        <SortByComponent sortType={sortType} onApplySort={onSortChange} />
      </Grid>
      */}
    </Grid>
  )
}

export default RecentBillsLedgerHeader
